import React, { useCallback, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegHandshake, FaExchangeAlt, FaUserCog } from "react-icons/fa";
import { FiBarChart } from "react-icons/fi";
import { FiRefreshCw } from "react-icons/fi";
import { LuUserRound } from "react-icons/lu";
import { RiDashboardLine } from "react-icons/ri";
// import Logo from "../Images/awqafLogo.png";
import Logo from "../Images/secondary_logo.svg";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { IoMenu } from "react-icons/io5";
import "./Header.css";

const Header = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // const parent =sessionStorage.getItem("parentPage");

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [parent, setParent] = useState(sessionStorage.getItem("parentPage"));
  const [username, setUsername] = useState(
    sessionStorage.getItem("userName") || ""
  );
  const [donationUR, setDonationUR] = useState("");

  useEffect(() => {
    const updateUserName = () => {
      setUsername(sessionStorage.getItem("userName") || "");
    };

    updateUserName();

    const interval = setInterval(updateUserName, 1000);
    return () => clearInterval(interval);
  }, []);

  // const username= sessionStorage.getItem("userName");

  const menuItems = [
    // {
    //   text: "Dashboard",
    //   icon: <RiDashboardLine />,
    //   route: "/dashboard",
    //   subRoutes: [],
    //   parentPage:"dashboard"
    // },
    {
      text: "Donation",
      icon: <FiBarChart />,
      route: "/subscription",
      subRoutes: ["/donationDetails"],
      parentPage:"DonationDetails"
    },
    {
      text: "Recurring Plans",
      icon: <FiRefreshCw />,
      route: "/RecurringPlans",
      subRoutes: ["/plansdetail"],
    },
    { text: "Account Settings", 
      icon: <LuUserRound />, 
      route: "/profile" },
  ];

  const logout = useCallback(() => {
    sessionStorage.removeItem("subscription_id");
    sessionStorage.removeItem("transactionId");
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("user_id");
    window.catalyst.auth.signOut("/");
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
  }, [sidebarOpen]);
  const handleMenuItemClick = (route) => {
    setTimeout(() => {
      navigate(route);
    }, 200);
  };


  useEffect(() => {
    const serverStatus = sessionStorage.getItem("Server");

    if (serverStatus === "development") {
      setDonationUR("https://dev-awqaf-platform.azurewebsites.net/");
    } else {
      setDonationUR("https://awqaf.org.au/");
    }
  }, []);

  const handleDonation = () => {
    if (donationUR) {
      window.open(donationUR, "_blank");
    }
  };

  return (
    <div className="flex min-h-screen overflow-hidden">
      <div
        className={`
        bg-white  fixed top-0 left-0 bottom-0 flex flex-col border-b-[1px] border-r-[1px] border-solid border-[#DEE3EC] max-sm:w-full  max-sm:bg-transparent max-sm:border-r-0 ${
          sidebarOpen ? "max-sm:-bottom-0" : "max-sm:bottom-[88%]"
        } max-sm:border-b-0`}
      >
        <div className="w-60 h-22 flex justify-center items-center border-b-[1px]   border-solid border-[#DEE3EC] bg-white max-sm:w-full max-sm:justify-between">
          <img src={Logo} alt="Logo" className="w-28 h-10 ml-0  max-sm:ml-4" />
          <button
            className="rounded-lg py-2 px-4 ml-0 donatebtn cursor-pointer hidden max-sm:block max-sm:w-[110px] max-sm:h-[40px] max-sm:right-[16%]"
            onClick={handleDonation}
          >
            <span className="DonateTypo cursor-pointer text-[18px] max-sm:text-[14px]">
              Donate Now
            </span>
          </button>
          <div className="invisible max-sm:visible text-2xl mr-[10px] cursor-pointer">
            <IoMenu className="text-[#0E5C57]" onClick={toggleSidebar} />
          </div>
        </div>
        <div
          className={`flex flex-col justify-between bg-[white] z-10 space-y-2 flex-grow max-sm:${
            sidebarOpen ? "flex" : "hidden"
          }`}
        >
          <div>
            <span
              className="font-[500] hidden text-[22px] max-sm:text-[21px] leading-[28.6px] mt-5 ml-2 mb-3 max-sm:block"
              style={{ fontFamily: "Jost" }}
            >
              👋 Welcome back, {username}
            </span>
            <ul>
            {menuItems.map((item, index) => {
            const parentPage = sessionStorage.getItem("parentPage");
            const isParentActive = parentPage === item.parentPage;

            const isSubRouteActive =
              location.pathname === item.route ||
              (item.subRoutes &&
                item.subRoutes.some((subRoute) =>
                  location.pathname.startsWith(subRoute)
                ));
            const isActive = isParentActive || isSubRouteActive;

                return (
                  <li key={index}>
                    <button
                      onClick={() => handleMenuItemClick(item.route)}
                      className={`flex items-center cursor-pointer py-2 w-full rounded-md ${
                        isActive ? "bg-[#F4F7F6]" : "bg-white"
                      }`}
                    >
                      <span
                        className={`font-[400] mr-3 ml-[15px] text-xl ${
                          isActive ? "text-[#0E5C57]" : "text-black"
                        }`}
                      >
                        {item.icon}
                      </span>
                      <span
                        className={`font-[400] text-[18px] ${
                          isActive ? "text-[#0E5C57]" : "text-black"
                        }`}
                      >
                        {item.text}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          <div
            class={`flex justify-center mb-4 ml-0 mr-0 logoutTypo cursor-pointer max-sm:${
              sidebarOpen ? "block" : "hidden"
            } max-sm:ml-4 max-sm:mr-4 bg-[white]`}
          >
            <button
              class="logoutBtn cursor-pointer w-[164px] h-[40px] max-sm:w-full"
              onClick={logout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      <div className="ml-60 flex-grow  max-sm:ml-0">
        <div className="fixed top-0 left-60 right-0 z-10 h-22 flex items-center  justify-between px-4 border-b-[1px] border-l-[1px] border-solid border-[#DEE3EC] welcomemsg bg-white max-sm:hidden">
          <span
            className="font-[500] text-[22px] leading-[28.6px]"
            style={{ fontFamily: "Jost" }}
          >
            👋 Welcome back, {username}
          </span>
          <button
            className="rounded-lg py-2 px-4 donatebtn mr-[30px] cursor-pointer w-[150px] h-[50px] right-[12px] block max-sm:hidden"
            onClick={handleDonation}
          >
            <span className="font-medium DonateTypo cursor-pointer">
              Donate Now
            </span>
          </button>
        </div>

        <div
          className={`pt-24 px-4 z-10  bg-[#F7F7F7] overflow-hidden max-sm:px-2 max-sm:z-[1000] ${
            sidebarOpen ? "hidden" : "block"
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Header;
